<!-- 首页-轮播图 -->
<template>
	<el-carousel :interval="5000" style="height: 100%" height="100%">
		<el-carousel-item
			v-for="(item, index) in swiperList"
			:key="item.id || index"
		>
			<img
				v-lazy="item.bgImg"
				:key="item.id || index"
				alt="首页"
				@click="$emit('handleTop', item.content)"
			/>
		</el-carousel-item>
	</el-carousel>
</template>

<script>
import { getSwiperList } from '@/network/home/index'
export default {
	name: 'HomeSwiper',
	data() {
		return {
			// 接口返回并按 id 排序后的全部图片（12 张）
			allSwiperList: [],
			// 当前宽度对应展示的 4 张
			swiperList: [],
		}
	},
	watch: {},
	created() {},
	mounted() {
		this.j_getSwiperList() //获取首页轮播图
		window.addEventListener('resize', this.updateSwiperByWidth)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.updateSwiperByWidth)
	},
	methods: {
		/** 按页面宽度取图组：0=1920前四张，1=1440中四张，2=手机端后四张 */
		getSwiperGroupIndex() {
			const width =
				window.innerWidth || document.documentElement.clientWidth || 0
			if (width <= 768) return 2
			if (width < 1680) return 1
			return 0
		},
		updateSwiperByWidth() {
			if (!this.allSwiperList.length) return
			const group = this.getSwiperGroupIndex()
			this.swiperList = this.allSwiperList.slice(group * 4, group * 4 + 4)
		},
		j_getSwiperList() {
			return new Promise((resolve, reject) => {
				getSwiperList().then((res) => {
					if (res.data.code === 200) {
						// 按 id 升序后使用：前4=1920，中4=1440，后4=手机端
						const dataList = (res.data.data || [])
							.slice()
							.sort((a, b) => Number(a.id) - Number(b.id))
							.map((item) => {
								return Object.assign({}, item, {
									bgImg: window.baseUrl + item.bgImg,
								})
							})
						this.allSwiperList = dataList
						this.updateSwiperByWidth()
						resolve()
					} else {
						reject()
					}
				})
			})
		},
	},
	components: {},
	computed: {},

	destroyed() {},
}
</script>
<style lang="scss" scoped>
.el-carousel {
	width: 100%;
	height: 100%;
}
::v-deep .el-carousel__container {
	height: 100% !important;
}
::v-deep .el-carousel__item {
	height: 100%;
}
img {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center;
	cursor: pointer;
}
::v-deep .el-carousel__indicators--horizontal {
	left: 50%;
	bottom: 2.0833vw;
	transform: translateX(-50%);
}
::v-deep .el-carousel__button {
	height: 4px;
	background-color: rgba(0, 0, 0, 0.15);
}
::v-deep .el-carousel__indicator.is-active button {
	background-color: #1d67e8;
}
@media screen and (max-width: 768px) {
	::v-deep .el-carousel__indicators--horizontal {
		bottom: 12px;
	}
	::v-deep .el-carousel__button {
		width: 18px;
		height: 4px;
		border-radius: 4px;
	}
}
</style>
